import { render, staticRenderFns } from "./AddDPPage.vue?vue&type=template&id=4969481e&scoped=true&"
import script from "./AddDPPage.vue?vue&type=script&lang=js&"
export * from "./AddDPPage.vue?vue&type=script&lang=js&"
import style0 from "./AddDPPage.vue?vue&type=style&index=0&id=4969481e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969481e",
  null
  
)

export default component.exports